<template>
  <div id="home">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col py-4">
          <h1 class="display-4 text-center">Locomotion Band Members Area</h1>
          <p class="lead">
            Band calender, submit bad dates, gig details, gig pay statements, submit songs, group chat, and more!
          </p>
          <p>Login <router-link to="/login" class="font-weight-bold">here</router-link>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {}
};
</script>

<style>
</style>